import styled from 'styled-components'

export const BottomSeparator = styled.div`
    hr {
        border-top: 1px solid rgba(32, 32, 32, 0.1);
    }
    box-shadow: 0px 1px 2px rgb(32 32 32 / 5%);
`
